<template>
    <div class="router-view-content" ref="content">
        <div style="display: flex; justify-content: space-between;">
            <h2>Kreator</h2>
            <div style="display: flex; align-items: center">
                <CheckBox
                    style="margin-right: 1rem"
                    color="apple"
                    @input="setManualAssets"
                    v-model="manualAssets"
                />
                <p>Ręczne dodawanie assetów</p>
            </div>
            <div v-if="editing">
                <ActionButton
                    materialIcon="delete"
                    label="Usuń kurs"
                    color="red"
                    @click="removeWebinar"
                    :loading="removalLoading"
                />
            </div>
        </div>
        <EditSection
            accent="apple"
            title="Podstawa"
            :errors="errors"
            :sections="mainSection"
            ref="mainSection"
            section="accountSections"
        />
        <EditSection
            accent="apple"
            title="Host"
            :errors="errors"
            :sections="hostSection"
            ref="accountSections"
            section="accountSections"
        />
        <EditSection
            accent="apple"
            title="Certyfikat"
            :errors="errors"
            :sections="certificateSection"
            ref="accountSections"
            section="accountSections"
        />
        <CourseModuleCreator :errors="errors" ref="modulesCreator" />
        <ActionButton
            :loading="loading"
            @click="submit"
            style="margin-top: 3rem;"
            color="apple"
            :label="editing ? 'Zapisz zmiany' : 'Utwórz course'"
        />
    </div>
</template>
<script>
export default {
    components: {
        CourseModuleCreator: () => import('./CourseModuleCreator')
    },
    data() {
        return {
            removalLoading: false,
            loading: false,
            manualAssets: false,
            errors: new this.$Errors(),
            mainSection: {
                title: {
                    required: true,
                    title: 'Tytuł',
                    value: '',
                    type: 'text-input',
                    key: 'title',
                    color: '#FFF',
                    size: 3
                },
                uuid: {
                    required: false,
                    title: 'UUID',
                    value: '',
                    type: 'text-input',
                    key: 'uuid',
                    color: '#FFF',
                    size: 1
                },
                visible: {
                    title: 'Widoczny dla userów?',
                    value: false,
                    options: {
                        false: this.$t('SWITCHER_NO'),
                        true: this.$t('SWITCHER_YES')
                    },
                    type: 'switch',
                    key: 'visible',
                    color: '#FFF',
                    size: 1
                },
                preview_url: {
                    required: false,
                    title: 'Preview URL',
                    value: '',
                    type: 'text-input',
                    key: 'preview_url',
                    color: '#FFF',
                    size: 1
                },
                product_details: {
                    title: 'Zawartość kursu',
                    value: '',
                    type: 'text-editor',
                    key: 'product_details',
                    color: '#FFF',
                    size: 3
                },
                description: {
                    title: 'Opis',
                    value: '',
                    type: 'text-editor',
                    key: 'description',
                    color: '#FFF',
                    size: 3
                },
                cost: {
                    required: true,
                    title: 'Koszt (w gr.)',
                    value: 0,
                    type: 'number-input',
                    key: 'cost',
                    color: '#FFF',
                    size: 1
                },
                old_cost: {
                    required: false,
                    title: 'Koszt przekreślony (w gr.)',
                    value: 0,
                    type: 'number-input',
                    key: 'old_cost',
                    color: '#FFF',
                    size: 1
                },
                thumbnail: {
                    autoUpload: true,
                    required: true,
                    title: 'Miniaturka',
                    value: '',
                    type: 'attachments-input',
                    single: true,
                    key: 'thumbnail',
                    color: '#FFF',
                    size: 2
                }
            },
            hostSection: {
                author_name: {
                    title: 'Imię i nazwisko hosta',
                    value: '',
                    type: 'text-input',
                    key: 'author_name',
                    color: '#FFF',
                    size: 3
                },
                author_description: {
                    title: 'Opis hosta',
                    value: '',
                    type: 'text-editor',
                    key: 'author_description',
                    color: '#FFF',
                    size: 3
                },
                author_image: {
                    title: 'Zdjęcie hosta',
                    value: '',
                    type: 'attachments-input',
                    single: true,
                    key: 'author_image',
                    color: '#FFF',
                    size: 2
                }
            },
            certificateSection: {
                certificate_title: {
                    title: 'Tytuł',
                    value: '',
                    type: 'area-input',
                    key: 'certificate_title',
                    color: '#FFF',
                    size: 3
                },
                certificate_description: {
                    title: 'Opis',
                    value: '',
                    type: 'area-input',
                    key: 'certificate_description',
                    color: '#FFF',
                    size: 3
                },
                certificate_host: {
                    title: 'Host',
                    value: '',
                    type: 'text-input',
                    key: 'certificate_host',
                    color: '#FFF'
                }
            }
        }
    },
    computed: {
        currentCourse() {
            return this.$route.params.course
        },
        editing() {
            return this.currentCourse != 'new'
        }
    },
    methods: {
        setManualAssets() {
            const assetInputType = this.manualAssets
                ? 'text-input'
                : 'attachments-input'
            const textInputType = this.manualAssets
                ? 'area-input'
                : 'text-editor'
            this.mainSection.thumbnail.type = assetInputType
            this.hostSection.author_image.type = assetInputType
            this.mainSection.product_details.type = textInputType
            this.mainSection.description.type = textInputType
            this.hostSection.author_description.type = textInputType
        },
        removeWebinar() {
            if (this.removalLoading) {
                return
            }
            this.removalLoading = true
            this.$api
                .remove(`v1/vod/courses/${this.currentCourse}`)
                .then(() => {
                    this.$router.push('/support/courses')
                })
                .catch(error => {
                    this.$Network.handleError(error)
                    this.removalLoading = false
                })
        },
        async submit() {
            if (this.loading) {
                return
            }
            await this.$refs.mainSection.uploadFiles()
            let data = {}
            const modules = await this.$refs.modulesCreator.getModules()
            if (
                !this.$Utils.setForm(this.mainSection, data, this.errors) ||
                !this.$Utils.setForm(this.hostSection, data, this.errors) ||
                !this.$Utils.setForm(this.certificateSection, data, this.errors)
            ) {
                this.$Notif.error('Niektóre pola są nieprawidłowo uzupełnione')
                return
            }
            if (!modules) {
                this.$Notif.error('Pola modułów nieuzupełnione')
                return
            }
            data.cost = parseInt(data.cost)
            data.old_cost = parseInt(data.old_cost)
            data.modules = modules
            this.loading = true
            try {
                if (this.editing) {
                    await this.$api.patch(
                        `v1/vod/courses/${this.currentCourse}`,
                        data
                    )
                } else {
                    await this.$api.post(`v1/vod/courses`, data)
                }
                await this.$store.dispatch('content/getCourses')
                this.$router.push('/support/courses')
                this.loading = false
            } catch (error) {
                this.$Network.handleError(error, this.errors)
                this.loading = false
            }
        },
        setForm() {
            if (!this.currentCourse || this.currentCourse == 'new') {
                return
            }
            const course = this.$store.state.content.courses.find(
                w => w.id == this.currentCourse
            )
            const sections = [
                'mainSection',
                'certificateSection',
                'hostSection'
            ]
            sections.forEach(section => {
                Object.keys(this[section]).forEach(key => {
                    if (this[section][key] && course[key] != undefined) {
                        this[section][key].value = course[key]
                    }
                })
            })
            setTimeout(() => {
                this.$refs.modulesCreator.setModules(course.modules)
            }, 500)
        },
        close() {
            this.$emit('close')
        }
    },
    mounted() {
        this.setForm()
    }
}
</script>
